import { render, staticRenderFns } from "./MuBang.vue?vue&type=template&id=256a7ac2&scoped=true&"
import script from "./MuBang.vue?vue&type=script&lang=js&"
export * from "./MuBang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256a7ac2",
  null
  
)

export default component.exports